import { cva } from 'class-variance-authority';

const inputLabelBaseStyles = [
    'select-none',
    'text-sm',
    'mb-1',
    'flex',

    'transition-all',

    'data-[float=true]:absolute',
    'data-[float=true]:text-xs',
    'data-[float=true]:left-4',
    'data-[float=true]:top-1',

    'data-[float=false]:absolute',
    'data-[float=false]:text-base',
    'data-[float=false]:left-4',
    'data-[float=false]:top-[10px]'
];

const inputLabelStylesSAG = cva([
    ...inputLabelBaseStyles,

    'text-[#66667E]',
    'peer-hover:text-[#000028]',
    'peer-focus:text-[#005159]',
    'peer-active:text-[#005159]',
    'peer-data-[invalid=true]:text-[#B81E31]',
    'peer-data-[invalid=true]:peer-hover:text-[#B81E31]',
    'peer-data-[invalid=true]:peer-focus:text-[#B81E31]',
    'peer-disabled:text-[#9999A9]',
    'peer-disabled:peer-hover:text-[#9999A9]',
    'peer-disabled:peer-focus:text-[#9999A9]',
    'peer-read-only:text-[#66667E]',
    'peer-read-only:peer-hover:text-[#66667E]',
    'peer-read-only:peer-focus:text-[#66667E]',

    'dark:text-[#9999A9]',
    'dark:peer-hover:text-[#FFFFFF]',
    'dark:peer-focus:text-[#00FFB9]',
    'dark:peer-active:text-[#00FFB9]',
    'dark:peer-data-[invalid=true]:text-[#FF7687]',
    'dark:peer-data-[invalid=true]:peer-hover:text-[#FF7687]',
    'dark:peer-data-[invalid=true]:peer-focus:text-[#FF7687]',
    'dark:peer-disabled:text-[#737389]',
    'dark:peer-disabled:peer-hover:text-[#737389]',
    'dark:peer-disabled:peer-focus:text-[#737389]',
    'dark:peer-read-only:text-[#9999A9]',
    'dark:peer-read-only:peer-hover:text-[#FFFFFF]',
    'dark:peer-read-only:peer-focus:text-[#FFFFFF]'
]);

const inputLabelStylesSHS = cva([
    ...inputLabelBaseStyles,
    'text-[#666666]',
    'peer-data-[invalid=true]:text-[#e7001e]',
    'peer-disabled:text-[#666666]',

    'dark:text-[#999999]',
    'dark:peer-data-[invalid=true]:text-[#e7001e]',
    'dark:peer-disabled:text-[#999999]'
]);

export { inputLabelStylesSAG, inputLabelStylesSHS };
